function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { Tooltip, IconButton, DropdownMenu, DropdownMenuItem } from 'seagull';
import { EditLine, MoreVertical, TrashLine, WideArrowDownward, WideArrowUpward } from 'seagull/icons';
import ServicePanel, { getTestId } from "../../ServicePanel/ServicePanel";
import styles from "./DraftServiceInstance.module.scss";
import { useServiceAdvancedSettingsAdditionalSection } from "../../ServiceAdvancedSettings";
const DraftServiceInstance = /*#__PURE__*/React.forwardRef(function DraftServiceInstance(props, ref) {
  const {
    service,
    idx,
    agreementData,
    canMoveDown,
    canMoveUp,
    isInvalid,
    advancedSettingsProps,
    showErrors,
    onInlineEditService,
    onEditService,
    onRemoveService,
    onMoveDown,
    onMoveUp,
    onHasError,
    onDayOfMonthChange,
    onDayOfWeekChange,
    onBillUpfrontModeChange
  } = props;
  const serviceAdvancedSettingsAdditionalSection = useServiceAdvancedSettingsAdditionalSection(_objectSpread(_objectSpread({}, advancedSettingsProps), {}, {
    service,
    testPrefix: "draft-service-".concat(idx)
  }));
  return /*#__PURE__*/React.createElement(ServicePanel, {
    isVendor: true,
    useBadges: true,
    ignoreAmendments: true,
    key: service.id || idx,
    ref: ref,
    service: service,
    idx: idx,
    agreementData: agreementData,
    error: showErrors && isInvalid,
    onCostChange: cost => onInlineEditService(_objectSpread(_objectSpread({}, service), {}, {
      cost
    })),
    additionalSections: [serviceAdvancedSettingsAdditionalSection],
    onHasError: onHasError,
    onDayOfMonthChange: onDayOfMonthChange,
    onDayOfWeekChange: onDayOfWeekChange,
    onBillUpfrontModeChange: onBillUpfrontModeChange,
    menu: /*#__PURE__*/React.createElement("div", {
      className: styles.inlineMenu
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: "Edit service for this proposal"
    }, /*#__PURE__*/React.createElement(IconButton, {
      onClick: () => onEditService(service),
      "data-testid": "".concat(getTestId(idx), "inline-menu-edit")
    }, /*#__PURE__*/React.createElement(EditLine, null))), /*#__PURE__*/React.createElement(Tooltip, {
      title: "Delete service for this proposal"
    }, /*#__PURE__*/React.createElement(IconButton, {
      onClick: () => onRemoveService(service.id),
      "data-testid": "".concat(getTestId(idx), "inline-menu-delete")
    }, /*#__PURE__*/React.createElement(TrashLine, null))), (canMoveDown || canMoveUp) && /*#__PURE__*/React.createElement(DropdownMenu, {
      target: /*#__PURE__*/React.createElement(IconButton, {
        "data-testid": "".concat(getTestId(idx), "ellipsis-menu")
      }, /*#__PURE__*/React.createElement(MoreVertical, null))
    }, /*#__PURE__*/React.createElement(DropdownMenuItem, {
      iconStart: /*#__PURE__*/React.createElement(WideArrowUpward, null),
      "data-testid": "".concat(getTestId(idx), "move-up"),
      disabled: !canMoveUp,
      onClick: onMoveUp
    }, "Move Up"), /*#__PURE__*/React.createElement(DropdownMenuItem, {
      iconStart: /*#__PURE__*/React.createElement(WideArrowDownward, null),
      "data-testid": "".concat(getTestId(idx), "move-down"),
      disabled: !canMoveDown,
      onClick: onMoveDown
    }, "Move Down")))
  });
});
export default DraftServiceInstance;